import './draft-ambient.css';

type AmbientBackgroundProps = {
  variant?: 'default' | 'player' | 'login';
};

function AmbientNoise() {
  return <div className="ambient-noise" aria-hidden />;
}

/** Draft AmbientBackground — 앱 셸 배경 */
export function AmbientBackground({ variant = 'default' }: AmbientBackgroundProps) {
  if (variant === 'player') {
    return (
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1428] via-[#0c101a] to-[#080a12]" />
        <div
          className="absolute inset-0 bg-cover bg-center blur-[80px] scale-110 opacity-50"
          style={{
            backgroundImage:
              "url('https://lh3.googleusercontent.com/aida-public/AB6AXuA0MigMZDY3yIGmWk9EBvuDdrJOgRdlzJrkhRQKhqaPvZhMHypJNnf-ElrhBTd8L8dXKoc8SsgZGyX_iw3XOsf0qPjxZQCylhxD1mq3iVnglPyO4MqYhvuWqNNzYjWiUFPou903ro8NcBaCWhUwUlVw5QrIOuNUWJOOa9s6DnGYhmrr9wIyDIudbzspyy8JF5nCQqgodUJooebKiqPUSote3cvNSPs3YohYNGNuFYsjgyYXRpns8NGTGKHQXCIxLTDYzHre-IJWpUo')",
          }}
        />
        <div className="ambient-orb ambient-orb--primary -top-[15%] -left-[10%] w-[65vw] h-[65vw] opacity-[0.35]" />
        <div className="ambient-orb ambient-orb--cyan -bottom-[20%] -right-[15%] w-[55vw] h-[55vw] opacity-[0.28]" />
        <AmbientNoise />
      </div>
    );
  }

  if (variant === 'login') {
    return (
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-[#242430] via-[#1e1e26] to-[#1a1a22]" />
        <div className="ambient-orb ambient-orb--primary -top-[30%] -left-[20%] w-[80vw] h-[80vw] opacity-[0.4]" />
        <div className="ambient-orb ambient-orb--cyan -bottom-[30%] -right-[20%] w-[70vw] h-[70vw] opacity-[0.32]" />
        <AmbientNoise />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-br from-[#262632] via-[#1f1f28] to-[#1a1a22]" />

      <div className="ambient-orb ambient-orb--primary -top-[25%] -left-[15%] w-[75vw] h-[75vw] max-w-[900px] max-h-[900px] opacity-[0.38]" />
      <div className="ambient-orb ambient-orb--cyan -bottom-[30%] -right-[10%] w-[70vw] h-[70vw] max-w-[800px] max-h-[800px] opacity-[0.3]" />
      <div className="ambient-orb ambient-orb--violet top-[35%] right-[5%] w-[50vw] h-[50vw] max-w-[600px] max-h-[600px] opacity-[0.22]" />

      <AmbientNoise />
    </div>
  );
}

export default AmbientBackground;
